import {signal} from "@preact/signals-react";

export const marketDetailsData = signal([])
export const isLoadingMarketDetails = signal(false)